'use strict';

var TabPane = require('./src/TabPane.js');
var Tabs$1 = require('./src/Tabs.js');

const Tabs = Tabs$1.Tabs;
Tabs.TabPane = TabPane.TabPane;

exports.Tabs = Tabs;
//# sourceMappingURL=index.js.map
